import Vue from "vue"
import * as types from "./mutation-types"
import {defaultState} from "@/modules/programacaoAbate/store/state"

export default {
  [types.SET_PROGRAMMING_TITLE](state, title) {
    let identificador = title != "" ? " #" + title : ""
    state.programmingTitle = "Programação para abate" + identificador
  },
  [types.SET_LISTA_DATAS](state, payload) {
    state.listaDatas = payload
  },
  [types.SET_LOADING](state, payload) {
    state.loading = payload
  },
  [types.SET_DEMAND_SAVED](state, payload) {
    state.demandSaved = payload
  },
  [types.SET_PLANTAS_ABATE](state, payload) {
    state.plantasAbate = payload
  },
  [types.SET_MUNICIPIOS](state, payload) {
    state.municipios = payload
  },
  [types.SET_PROGRAMMING_SELECTED](state, resp) {
    state.programacaoAbateSelected.idProgramacaoAbate =
      resp.idProgramacaoAbate == undefined ? 0 : resp.idProgramacaoAbate
    state.programacaoAbateSelected.cdStatusProgramacaoAbate =
      resp.cdStatusProgramacaoAbate == undefined
        ? 0
        : resp.cdStatusProgramacaoAbate
    state.programacaoAbateSelected.dtInicioAbate = resp.dtInicioAbate
    state.programacaoAbateSelected.dtFimAbate = resp.dtFimAbate
    state.programacaoAbateSelected.nrProgramacaoAbate = resp.nrProgramacaoAbate
    state.isSlaughterScheduleSelected = true
  },
  [types.SET_LISTA_DEMANDAS](state, data) {
    state.listaDemandasPlanta = data
  },
  [types.SET_ANIMAIS_ITEM_DEMANDAS](state, item) {
    let demanda = state.listaDemandasPlanta.find(
      x => x.plantaAbate.idPlantaAbate == item.cdPlanta
    )
    demanda[item.valueLista] = item.qtAnimais
    
    let totalAnimais = 0
    let contadorItens = 0
    for (var [key, value] of Object.entries(demanda)) {
      if (
        key != "idProgramacaoAbateDemanda" &&
        key != "plantaAbate" &&
        key != "qtTotalDemanda" &&
        key != "demandaPreenchida" &&
        key != "cdPlantaAbate" &&
        key != "cdProgramacaoAbate"
      ) {
        if (value != "") {
          totalAnimais = totalAnimais + parseInt(value)
          contadorItens++
        }
      }
    }
    if (contadorItens == 7) {
      demanda["demandaPreenchida"] = true
    } else {
      demanda["demandaPreenchida"] = false
    }
    demanda["qtTotalDemanda"] = totalAnimais
  },
  [types.SET_PAGE_BATCHS_AVALIABLE](state, page) {
    state.pageBatchsAvaliable = page
  },
  [types.SET_BATCHS_AVALIABLE](state, baths) {
    state.listBathsAvaliable = baths
  },
  [types.SET_LIST_EXTENSIONISTAS](state, extensionistas) {
    state.listExtensionistas = extensionistas
  },
  [types.SET_LIST_TIPOS_GENERO](state, tiposGenero) {
    state.listTiposGenero = tiposGenero
  },
  [types.SET_EDITING_ITEM_BATCH_AVALIABLE](state, id) {
    state.listBathsAvaliable.forEach(function (i) {
      i.isEditing = false
    })
    let item = state.listBathsAvaliable.find(x => x.idLoteProducao == id)
    item.isEditing = true
  },
  [types.SET_PROGRAMACOES_PLANTA](state, registros) {
    let programacoes = []
    registros.forEach(function (lote) {
      let newRec = {
        cdLoteProducao: lote.idLoteProducao,
        cdProgramacaoAbate: state.programacaoAbateSelected.idProgramacaoAbate,
        loteProducao: lote,
        cdPlantaAbate: planta.idPlantaAbate,
        plantaAbate: planta,
        qtAnimaisAlocados: 0,
        nrPesoDia: lote.nrPesoProjetado
      }
      programacoes.push(newRec)
    })
    state.listaProgramacoesPlanta = programacoes
  },
  [types.SET_CITIES](state, cities) {
    state.cities = cities || []
  },
  [types.SET_AVAILABLE_LOTS](state, {cdPlantaAbate, availableLots}) {
    Vue.set(state.availableLots, cdPlantaAbate, availableLots || [])
  },
  [types.REMOVE_INSERTED_LOTS](state, insertedLots) {
    for (const id of insertedLots) {
      const idx = state.availableLots.findIndex(
        lot => lot["idLoteProducao"] === id
      )
      if (idx > -1) {
        state.availableLots.splice(idx, 1)
      }
    }
  },
  [types.SET_AVAILABLE_LOTS_META](state, {cdPlantaAbate, availableLotsMeta}) {
    Vue.set(state.availableLotsMeta, cdPlantaAbate, availableLotsMeta)
  },
  [types.SET_AVAILABLE_LOTS_CURR_PAGE](state, {cdPlantaAbate, page}) {
    Vue.set(state.availableLotsCurrPage, cdPlantaAbate, page)
  },
  [types.SET_SLAUGHTER_PLANT_ESTABLISHMENTS](
    state,
    slaughterPlantEstablishments
  ) {
    state.slaughterPlantEstablishments = slaughterPlantEstablishments
  },
  [types.CLEAR_AVAILABLE_LOTS](state) {
    state.availableLotsCurrPage = {}
    state.availableLotsMeta = {}
    state.availableLots = {}
  },
  [types.CLEAR_ALLOCATED_LOTS](state) {
    state.listBatchsAlreadyAllocated = []
    state.listBatchsAllocated = []
    state.listCheckListAlocados = []
  },
  [types.CLEAR_DEMAND_VALUES](state) {
    state.listaDemandasPlanta = []
    state.listDatesWithDemand = []
  },
  [types.SET_SHOW_LOTES_PLANTA_ABATE](state, itemDemandaPlanta) {
    let item = state.listaDemandasPlanta.find(
      x =>
        x.idProgramacaoAbateDemanda ==
        itemDemandaPlanta.idProgramacaoAbateDemanda
    )
    if (item.showLotes) {
      item.showLotes = !item.showLotes
    } else {
      item.showLotes = true
    }
  },
  [types.SET_LIST_DATES_WITH_DEMAND](state, registro) {
    const list = []
    state.listaDatas.forEach(date => {
      registro.forEach(demand => {
        if (demand[date.value] > 0) {
          let item = list.filter(x => x.value == date.value)
          if (item.length == 0) {
            list.push(date)
          }
        }
      })
    })
    Vue.set(state, "listDatesWithDemand", list)
  },
  [types.SET_LIST_BATCHS_ALLOCATED](state, registros) {
    Vue.set(state, "listBatchsAllocated", registros)
  },
  [types.SET_DISTANCIA_ESTABELECIMENTO_PLANTA](state, registro) {
    let alocado = state.listBatchsAllocated.find(
      x => x.idProgramacaoAbateAlocado == registro.cdProgramacaoAbateAlocado
    )
    alocado.distanciaPlanta.dsTipo = registro.estabelecimentoPlanta[0].dsTipo
    alocado.distanciaPlanta.nrValor = registro.estabelecimentoPlanta[0].nrValor
  },
  [types.SET_NEW_VALUE_EDIT_WEIGHT](state, registro) {
    let alocado = state.listBatchsAllocated.find(
      x => x.idProgramacaoAbateAlocado == registro.idProgramacaoAbateAlocado
    )
    alocado.editarPeso = !alocado.editarPeso
  },
  [types.SET_NEW_VALUE_WEIGHT_ALLOCATED](state, registro) {
    let alocado = state.listBatchsAllocated.find(
      x =>
        x.idProgramacaoAbateAlocado ==
        registro.valueLote.idProgramacaoAbateAlocado
    )
    alocado.nrPesoDia = registro.nrPeso
  },
  [types.SET_NEW_VALUE_QT_ANIMALS_ALLOCATED](state, registro) {
    let alocado = state.listBatchsAllocated.find(
      x =>
        x.idProgramacaoAbateAlocado ==
        registro.valueLote.idProgramacaoAbateAlocado
    )
    alocado.qtAnimaisAlocados = registro.qtAnimais
    
    state.listBatchsAllocated.forEach(item => {
      if (item.cdLoteProducao == alocado.cdLoteProducao) {
        item.qtAnimaisProgramadoAbate = registro.qtAnimais
      }
    })
    
    let totalAlocadosLote = 0
    state.listBatchsAllocated.forEach(function (loteAlocado) {
      if (loteAlocado.cdLoteProducao == alocado.cdLoteProducao) {
        totalAlocadosLote =
          (parseInt(totalAlocadosLote) || 0) +
          (parseInt(loteAlocado.qtAnimaisAlocados) || 0)
      }
    })
    
    state.listBatchsAllocated.forEach(function (loteAlocado) {
      if (loteAlocado.cdLoteProducao == alocado.cdLoteProducao) {
        loteAlocado.qtAnimaisDisponiveis =
          (parseInt(loteAlocado.loteProducao.qtSaldoAnimais) || 0) -
          (parseInt(totalAlocadosLote) || 0) -
          ((parseInt(loteAlocado.loteProducao.qtAnimaisProgramadoAbate) || 0) +
            (parseInt(loteAlocado.qtAnimaisProgramadoAbate) || 0))
      }
    })
  },
  [types.SET_CHECK_LIST_PROGRAMACAO_ABATE_ALOCADO](state, registro) {
    let item = state.listCheckListAlocados.find(
      x => x.idCheckList == registro.checkList[0].idCheckList
    )
    if (item == undefined) {
      state.listCheckListAlocados.push(registro.checkList[0])
    }
  },
  [types.SET_NEW_VALUE_PERIODO_CARREGAMENTO_CHECKLIST](state, registro) {
    let checkList = state.listCheckListAlocados.find(
      x => x.idCheckList == registro.valueCheckList.idCheckList
    )
    checkList.stAbatePeriodo = registro.stAbatePeriodo
  },
  [types.SET_LOTE_ALOCADO_QT_ANIMAIS](
    state,
    {idProgramacaoAbateAlocado, value}
  ) {
    const foundLot = state.listBatchsAllocated.find(
      item => item.idProgramacaoAbateAlocado === idProgramacaoAbateAlocado
    )
    Vue.set(foundLot, "qtAnimaisAlocados", value)
    // foundLot.qtAnimaisAlocados = value
    foundLot.blChanged = true
  },
  [types.SET_LOTE_ALOCADO_NR_PESO](
    state,
    {idProgramacaoAbateAlocado, value}
  ) {
    const foundLot = state.listBatchsAllocated.find(
      item => item.idProgramacaoAbateAlocado === idProgramacaoAbateAlocado
    )
    foundLot.nrPesoDia = value
    foundLot.blChanged = true
  },
  [types.REMOVE_LOTE_ALOCADO_WITH_CHECKLIST](state, alocado) {
    const lot = state.listBatchsAllocated.find(
      item =>
        item.idProgramacaoAbateAlocado === alocado.idProgramacaoAbateAlocado
    )
    if (lot) {
      Vue.set(lot, "blDeleted", true)
    }
  },
  [types.RECOVER_LOTE_ALOCADO_WITH_CHECKLIST](state, alocado) {
    const lot = state.listBatchsAllocated.find(
      item =>
        item.idProgramacaoAbateAlocado === alocado.idProgramacaoAbateAlocado
    )
    if (lot) {
      Vue.set(lot, "blDeleted", false)
    }
  },
  [types.REMOVE_LOTE_ALOCADO_WITHOUT_CHECKLIST](state, alocado) {
    const idx = state.listBatchsAllocated.findIndex(
      item =>
        item.idProgramacaoAbateAlocado === alocado.idProgramacaoAbateAlocado
    )
    if (idx > -1) {
      state.listBatchsAllocated.splice(idx, 1)
    }
  },
  [types.CLEAR_LOTE_ALOCADO_LIST](state) {
    const filtered = state.listBatchsAllocated.filter(item => item.blDeleted)
    filtered.forEach(x => {
      const idx = state.listBatchsAllocated.findIndex(
        i => i.idProgramacaoAbateAlocado === x.idProgramacaoAbateAlocado
      )
      if (idx > -1) {
        state.listBatchsAllocated.splice(idx, 1)
      }
    })
  },
  [types.SET_CAN_EDIT_DEMANDS](state, value) {
    state.canEditDemands = value
  },
  [types.CLEAR_ALL](state) {
    Object.assign(state, defaultState(), {})
  },
  [types.SET_NEW_STATUS_PROGRAMACAO](state, value) {
    Vue.set(state.programacaoAbateSelected, "cdStatusProgramacaoAbate", value)
  },
  [types.CHANGE_DIALOG_BATCHS_AVALIABLE](state, value) {
    state.dialogBathsAvaliable = value
  },
  [types.SET_COPYING](state, value) {
    state.isCopying = value
  },
  [types.SET_CUTTING](state, value) {
    state.isCutting = value
  },
  [types.SET_ID_PROGRAMACAO_ABATE_ALOCADO_TO_COPY](state, value) {
    state.idProgramacaoAbateAlocadoToCopy = value
  },
  [types.PASTE_PROGAMACAO_ABATE_ALOCADO](state, {
    stDiaAlocado,
    dtAlocado,
    cdPlantaAbate,
    nrPesoDia
  }) {
    if (!state.idProgramacaoAbateAlocadoToCopy) return
    const foundLot = state.listBatchsAllocated.find(item => (
      item.idProgramacaoAbateAlocado === state.idProgramacaoAbateAlocadoToCopy
    ))
    if (!foundLot) return
    
    foundLot.stDiaAlocado = stDiaAlocado
    foundLot.dtAlocado = dtAlocado
    foundLot.cdPlantaAbate = cdPlantaAbate
    foundLot.nrPesoDia = nrPesoDia
    foundLot.blChanged = true
    
    state.idProgramacaoAbateAlocadoToCopy = null
  },
  [types.CLEAR_PROGAMACAO_ABATE_ALOCADO_TO_COPY](state) {
    state.isCutting = false
    state.isCopying = false
    state.idProgramacaoAbateAlocadoToCopy = null
  }
}
